<template>
    <div>
        <section class="basic-info">
            <v-container>
                <v-row v-if="team !== null">
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <h2 class="section-subtitle">Základní údaje</h2>
                        <v-row>
                            <v-col cols="16" md="10" offset-md="3" sm="14" offset-sm="1">
                                <v-row>
                                    <v-col cols="16" md="4" sm="6" class="blazon">
                                        <team-blazon-view
                                            :settings="team.blazon"
                                        />
                                        <team-blazon-builder v-if="editing" @close="editing = false" :current-blazon="team.blazon" />
                                        <v-btn @click.stop="editing = true" v-if="isOwner" type="submit" dark class="primary margintop20">
                                            Upravit erb
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="16" offset="0" md="11" offset-md="1" sm="9" offset-sm="1" class="d-flex flex-column">
                                        <v-form>
                                            <v-text-field
                                                dark
                                                :value="team.name"
                                                label="Název teamu"
                                                :readonly="true"
                                            />
                                            <v-text-field
                                                dark
                                                :value="team.owner.nickname"
                                                label="Majitel týmu"
                                                :readonly="true"
                                            />
                                        </v-form>
                                        <leave-team v-if="team.permissions.canLeave"/>
                                        <disband-team v-else-if="team.permissions.canDisband"/>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section v-if="team !== null" class="team-members">
            <team-members
                :players="team.players"
                :can-fire-member="team.permissions.canFireMember"
            />
        </section>
        <section v-if="canAddMember" class="add-member">
            <add-member />
        </section>
        <section v-if="canAddMember" class="new-members">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <team-requests />
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>
<script>
    import { mapState, mapGetters } from 'vuex'
    import TeamBlazonBuilder from '../TeamBlazon/TeamBlazonBuilder';
    import TeamBlazonView from '../TeamBlazon/TeamBlazonView';
    import DisbandTeam from './DisbandTeam'
    import LeaveTeam from './LeaveTeam'
    import TeamMembers from './TeamMembers';
    import TeamRequests from './TeamRequests'
    import AddMember from './AddMember';

    export default {
        name: 'MyTeam',
        components: {
            TeamBlazonView,
            TeamBlazonBuilder,
            AddMember,
            DisbandTeam,
            LeaveTeam,
            TeamMembers,
            TeamRequests,
        },
        props: {},
        computed: {
            ...mapState({
                team: state => state.team.myTeam,
            }),
            ...mapGetters('team', [
                'canAddMember',
            ]),
            isOwner () {
                return this.team && this.team.permissions.isOwner;
            },
        },
        data () {
            return {
                editing: false,
            }
        },
    }
</script>
